import {
  applyOverrides,
  propertyBeingSoldCard as basePropertyBeingSoldCard,
} from '../../../shared';

export const propertyBeingSoldCard = applyOverrides(basePropertyBeingSoldCard, {
  id: 'propertyInfo.propertyBeingLeased',
  innerTitle: 'Property Being Leased',
});
